import _ from 'underscore';

export function updateOdataOptionsForLevel(options) {
  const optionsCopy = options || { custom: {} };

  _.extendOwn(optionsCopy.custom, {
    LevelOfDetails: {
      eq: (val) => {
        const enmu = val.replace('Enum.LevelOfDetails', '');
        return `LevelOfDetails eq ${enmu}`;
      },
    },
  });

  return optionsCopy;
}
